import { Badge } from '@design-system';
import { Check } from 'lucide-react';

export function SectionStatusBadge({ missing }: { missing: number }) {
  return missing ? (
    <Badge variant="warning">{missing} missing</Badge>
  ) : (
    <Badge variant="success">
      <Check />
      Complete
    </Badge>
  );
}
